




















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { BaseDialog, Button, Input, Dropdown, Textbox } from "@brankas/web-ui";

import { ECountryCode } from "@/pagesCom/ClientInfo/index.dto";
import { IntegrationItem, ProductItem } from "@/types";
import { required, requiredIf } from "vuelidate/lib/validators";
import { EmailAdvisoryTemplate } from "@/proto/admin/all_pb";
import { addHTMLLineBreak } from "@/utils/text-utils";

@Component({
  components: {
    BaseDialog,
    Button,
    Input,
    Dropdown,
    Textbox,
  },
  validations: {
    form: {
      reason: { required },
      notes: {},
      body: {
        required: requiredIf((form) => {
          return form.reason === EmailAdvisoryTemplate.CUSTOM;
        })
      },
      title: {
        required: requiredIf((form) => {
          return form.reason === EmailAdvisoryTemplate.CUSTOM;
        })
      },
    },
  },
})
export default class ToggleStatusDialog extends Vue {
  @Prop({ type: String, default: "" }) selectedProductName!: string;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: Boolean, default: false }) isToggleToDisable!: boolean;
  @Prop({ type: Object, default: () => ({}) }) data!:
    | IntegrationItem
    | ProductItem;
  @Prop({ type: Array, default: () => [] }) advisoryReasons!: [];

  mounted() {
    if (!this.isServiceLevel) {
      this.form.reason = this.isToggleToDisable ? EmailAdvisoryTemplate.BRANKAS_SCHEDULED_MAINTENANCE : EmailAdvisoryTemplate.BRANKAS_SCHEDULED_MAINTENANCE_RESTORED;
    }
  }

  form = {
    reason: null,
    notes: '',
    body: '',
    title: '',
  };

  get countryName(): string {
    return ECountryCode[this.data.country];
  }

  get productsCount(): number {
    return Object.keys(this.data.products || {}).length;
  }

  get isServiceLevel(): boolean {
    return !!this.data.id;
  }

  get isCustomEmail(): boolean {
    return this.form.reason === EmailAdvisoryTemplate.CUSTOM;
  }

  onCancel() {
    this.$emit("cancel");
  }

  onSubmit() {
    this.$v.$touch();
    if (this.$v.$invalid) return;

    const data = Object.assign({}, this.form);
    data.body = addHTMLLineBreak(data.body);

    this.$emit("confirm", data);
  }
}
